import React from "react";
import { FaQuestionCircle } from "react-icons/fa";
import { Link } from "react-router-dom";

const PageNotFound = () => {
	return (
		<>
			<div class="mainbox">
				<div class="err">4</div>
				<FaQuestionCircle color="var(--darkBlue)" className="fa-spin far" />
				<div class="err2">4</div>
				<div class="msg">
					Maybe this page moved? Got deleted? Is hiding out in quarantine? Never
					existed in the first place?
					<p>
						Let's go <Link to="/">home</Link> and try from there.
					</p>
				</div>
			</div>
		</>
	);
};

export default PageNotFound;
